import { createTheme } from '@mui/material';
import { Theme as MuiTheme } from '@mui/material';
declare module '@emotion/react' {
  export interface Theme extends MuiTheme {}
  export interface DefaultTheme extends MuiTheme {}
}
declare module '@emotion/styled' {
  export interface Theme extends MuiTheme {}
  export interface DefaultTheme extends MuiTheme {}
}

export default createTheme({
  palette: {
    mode: 'light',
  },
  typography: {
    fontFamily: 'Segoe UI',
    button: {
      textTransform: 'none',
    },
    fontSize: 13,
  },
});
